import { Action } from 'redux'
import { combineEpics, createEpicMiddleware } from 'redux-observable'
import { IState } from '../reducers'
import cardsdestinosEpics from './cardsdestinosEpics'
import cardsinstagramEpics from './cardsinstagramEpics'
import cardspartnersEpics from './cardspartnersEpics'
import cardspressEpics from './cardspressEpics'
import cardstourdesksEpics from './cardstourdesksEpics'
import carouseltoppagesEpics from './carouseltoppagesEpics'
import contactsEpics from './contactsEpics'
import seccionfinanzasEpics from './seccionfinanzasEpics'
import seccionitsEpics from './seccionitsEpics'
import seccionmarketingsEpics from './seccionmarketingsEpics'
import seccionsociosEpics from './seccionsociosEpics'
import seccionturismosEpics from './seccionturismosEpics'
import toppagesaboutusEpics from './toppagesaboutusEpics'
import toppagesjoinusEpics from './toppagesjoinusEpics'
import toppagespressEpics from './toppagespressEpics'
import usersEpics from './usersEpics'

export const rootEpic = combineEpics(
  usersEpics,
  cardsdestinosEpics,
  cardstourdesksEpics,
  seccionsociosEpics,
  cardspressEpics,
  contactsEpics,
  cardsinstagramEpics,
  seccionmarketingsEpics,
  seccionitsEpics,
  seccionturismosEpics,
  seccionfinanzasEpics,
  cardspartnersEpics,
  carouseltoppagesEpics,
  toppagespressEpics,
  toppagesjoinusEpics,
  toppagesaboutusEpics
)

export default createEpicMiddleware<Action, Action, IState>()
